//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface DescriptionQuillProps {
  field: {
    name: string;
    value: string;
    onChange: (event: {
      target: {
        name: string;
        value: string | undefined;
      };
    }) => void;
  };
  [key: string]: any;
}

const DescriptionQuill: React.FC<DescriptionQuillProps> = ({
  field,
  ...props
}) => {
  const quillRef = useRef<ReactQuill>(null);

  useEffect(() => {
    if (quillRef.current) {
      // Editor
      const quillEditor = quillRef.current.getEditor();
      quillEditor.format("align", "right");
      quillEditor.root.style.textAlign = "right";
      quillEditor.root.style.fontFamily = "Vazir";
      quillEditor.root.style.fontStyle = "normal";

      // Editing Area
      const quillContainer = quillRef.current.editingArea;
      quillContainer.style.borderRadius = "8px";

      const style = document.createElement("style");
      style.innerHTML = `
        .ql-editor li.ql-align-right::before {
            margin-right: 0px !important;
            margin-left: 0px !important;
            text-align: right !important;
        }
            
        .ql-editor a {
          color: blue !important;
          text-decoration: underline !important;
        }
        `;

      document.head.appendChild(style);
    }
  }, []);

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link"],
    ],
  };

  return (
    <ReactQuill
      value={field.name}
      placeholder="توضیحات خود را بنویسید"
      ref={quillRef}
      className={"mb-4"}
      {...field}
      {...props}
      modules={modules}
      onKeyUp={() => {
        const value = quillRef?.current?.getEditor().root.innerHTML;

        field.onChange({
          target: {
            name: field.name,
            value,
          },
        });
      }}
      onBlur={() => {}}
    />
  );
};

export default DescriptionQuill;
